import React from "react";
import * as actions from './Actions';
// import Jaw from './Jaw';
import Service from '../../service/Service';
const service = new Service();

export default function BabyTeethingSection ({teethingData, eleRef}){
    return(
        <section className="babyteeth-section">
            <div className="section-title">Baby Teething</div>
            <div className="teething-main">
                {teethingData.tooth && teethingData.tooth.map((tooth, id) => 
                <div key={id} className="teething-block">
                    <div className="jaw-img left">
                        <img src={`https://cdn.cdnparenting.com/brainbees/community/preact/public/media/teeth-${tooth.jaw_type}-${tooth.position}-${tooth.tooth_number}.svg`} />
                        {/* <Jaw /> */}
                    </div>
                    <div className="teething-info left">
                        <div className="M15_42 tooth-name">{tooth.tooth_name} is about to 
                        {tooth.start_month_eruption ?
                            " erupt"
                        : tooth.start_year_shedding &&
                            " shed"
                        }
                        </div>
                        {tooth.start_month_eruption ?
                        <div className="R13_75">Suggested age group {tooth.start_month_eruption} to {tooth.end_month_eruption} months</div>
                        : tooth.start_year_shedding &&
                        <div className="R13_75">Suggested age group {tooth.start_year_shedding} to {tooth.end_year_shedding} years</div>
                        }
                        <div className="askB_1 dev_teeth">
                            <a href={`/tools/baby-teething`} id="dev_abt_clk">
                            {tooth.start_month_eruption ? 
                                "LEARN ABOUT ERUPTION"
                            : tooth.start_year_shedding &&
                                "LEARN ABOUT SHEDDING"
                            }
                            </a>
                            {/* <a href={`/tools/baby-teething/${tooth.jaw_type}-${tooth.position}-${service.genquestionurl(tooth.tooth_name)}-tooth-${tooth.id}`}>
                            LEARN ABOUT ERUPTION
                            </a> */}
                        </div>
                    </div>
                </div>
                )}
            </div>
            {teethingData.search_cnt > teethingData.tooth.length &&
            <div className="moreResults dev_v_all" title="Baby Teething" onClick={()=>eleRef.getMoreSearchData(teethingData.type)}>SEE MORE RESULTS</div>
            }
        </section>
    );
}
